@use '@pes-ui/styles/src/mixins';

.pes-app-pdp__section {
  margin-top: 20px;

  @include mixins.for-desktop-only {
    margin-top: 8px;
  }
}
